import { AxiosInstance } from 'axios';
import Header from '@naruto/naruto-api/src/tools/Header';
import Immerable from '@naruto/naruto-models/src/types/GeneralImmer';
import { AxiosError, BaseResponse, BaseErrorStack } from './types';

class BaseAPI extends Immerable {
  public axios: AxiosInstance;

  public header: Header;

  constructor({ axios, header }: { axios: AxiosInstance; header: Header }) {
    super();
    this.axios = axios;
    this.header = header;
  }

  generatorAPIError(error: AxiosError | Error | any): BaseResponse {
    const responseData: BaseResponse = {
      status: 0,
      headers: {}
    };
    if ('isAxiosError' in error) {
      const newError = error as AxiosError<BaseErrorStack>;
      responseData.status = Number(error.response?.status);
      responseData.headers = newError.response?.headers;
      responseData.error = newError.response?.data;
    } else {
      const newError = error as Error;
      responseData.error = {
        success: false,
        message: '',
        errors: {
          error_stack: [`${newError.stack}`],
          error_message: [newError.message]
        }
      };
    }
    return responseData;
  }
}

export default BaseAPI;
